import React, {useState} from 'react';
import {Tag, Upload, UploadFile} from 'antd';
import {ERROR_MESSAGES} from '@/constants/messages';
import {handleError} from '@/utils/helpers';
import {uploadAndTranscribeAudio} from '@/utils/file-upload';
import audioUpload from "@/pages/AfterMeet/static/audioUpload.png";
import { useSnapshot } from 'valtio/react';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';
import {UploadChangeParam} from 'antd/es/upload';

interface AudioParserProps {
  fList?: UploadFile[];
  setA2tNotice: (notice: string) => void;
  fileChange: (fileInfo: UploadChangeParam<UploadFile>) => void;
  setData: (docParam: Record<string, string>) => void;
}

const AudioParser: React.FC<AudioParserProps> = ({ fList, setA2tNotice, fileChange, setData }) => {
  const [parsedContent, setParsedContent] = useState<Record<string, string>>({});
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  const isNotLogin = !supabaseAuth.isLoading && !supabaseAuth.isAuthenticated && supabaseAuth.user === undefined;
  const [isLoad, setIsLoad] = useState(false);

  const customRequest = async (options: any) => {
    const { file, onProgress, onSuccess, onError } = options;
    try {
      setIsLoad(true);
      
      // 使用统一的上传转录方法（包含预处理、上传、转录）
      const result = await uploadAndTranscribeAudio(file, {
        onProgress: (progress) => {
          onProgress({ percent: progress.percent }, file);
        },
        onStatusChange: (status) => {
          setA2tNotice(status);
        },
      });
      
      // 转录成功
      parsedContent[file.name] = result.transcription;
      setData({ ...parsedContent });
      onSuccess?.(result, file);
      
    } catch (error: any) {
      handleError(error, `${file.name} ${ERROR_MESSAGES.UPLOAD_ERROR}: ${error?.message || '未知错误'}`);
      onError?.(error);
    } finally {
      setIsLoad(false);
    }
  };

    return (
      <div>
        <Upload
          name="file"
          accept=".wav,.m4a,.aac,.mp3,.ogg"
          beforeUpload={(file) => {

            if(isNotLogin){
              handleError(null,`未登录不支持语音转录`);
              return false;
            }

            // 文件大小限制（50MB）
            const maxSize = 2*1024 * 1024 * 1024;
            if (file.size > maxSize) {
              handleError(null,'文件大小不能超过2GB');
              return false;
            }
            return true;
          }}
          fileList={fList}
          customRequest={customRequest} // 覆盖默认上传行为
          onRemove={false}

          showUploadList={false}
          iconRender={()=><Tag color="cyan-inverse">音频</Tag>}
          maxCount={1}
          onChange={info => {
            console.log("audio file change",info);
            fileChange(info);
          }}
          disabled={isLoad}
        >

          <div className="flex items-center gap-1.5 cursor-pointer">
            <svg className="w-3.5 h-3.5 text-[#73726E]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m-4-4h8m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
            </svg>
            <span className="text-[11px] text-[#73726E]">补充录音</span>
          </div>

        </Upload>
      </div>
    );
  }
;

export default AudioParser;